// extracted by mini-css-extract-plugin
export var modal = "_ex-0";